<!--
 * @Author: your name
 * @Date: 2020-08-26 15:52:26
 * @LastEditTime: 2024-07-31 17:45:38
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares\src\components\system\OrganizationManage.vue
-->
<template>
  <div class="organization-manage">
    <enfold>
      <enfold-uc>
        <template slot="up">
          <div class="c-u-left">{{$t('system.StructureName')}}</div>
          <div class="c-u-right">{{$t('system.Operate')}}</div>
        </template>
        <template slot="center">
          <el-tree :data="groupList" :props="{children: 'child', label: 'name'}" default-expand-all :expand-on-click-node="false" v-loading="loading">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <img class="icon" src="@/assets/images/public/public_add.png" @click="() => append(data)" alt />
                <img class="icon" src="@/assets/images/public/public_edit.png" @click="() => edit(data)" alt />
                <img class="icon" src="@/assets/images/public/public_delete.png" @click="() => remove(data)" alt />
                <img class="icon" :src="parseInt(data.run_status) ?switchON: switchOFF" @click="() => organizationSwitch(data)" alt />
              </span>
            </span>
          </el-tree>
        </template>
      </enfold-uc>
    </enfold>
    <form-dialog :dialogVisible="FormDialogVisible" @closeDialog="FormCloseDialog" :title="$t('system.NewStructure')" dWidth="400px">
      <div class="form-dialog">
        <el-form :model="listForm" :rules="rules" ref="listForm" label-width="124px">
          <el-form-item :label="$t('system.StructureName')" prop="name">
            <el-input v-model="listForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('listForm')" round>{{$t('basics.Cancel')}}</el-button>
            <el-button type="primary" @click="submitForm('listForm')" round>{{$t('basics.Confirm')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
    <form-dialog :dialogVisible="editDialogVisible" @closeDialog="editCloseDialog" title="修改组织结构名称" dWidth="400px">
      <div class="form-dialog">
        <el-form :model="editForm" :rules="rules" ref="editForm" label-width="124px">
          <el-form-item :label="$t('system.StructureName')" prop="name">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetEdit('editForm')" round>{{$t('basics.Cancel')}}</el-button>
            <el-button type="primary" @click="submitEdit('editForm')" round>{{$t('basics.Confirm')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('system.DeleteStructure')">
      <div class="dd-dialog">{{$t('system.MsgDeleteStructure')}}({{groupItem.name}}){{$t('system.Structure')}}?</div>
    </del-dialog>
    <banned-dialog :dialogVisible="onOffDialogVisible" @closeDialog="onOffCloseDialog" :buttonName="isSwitch" :title="isSwitch[2]?$t('system.OnDevice'):$t('system.OffDevice')">
      <div class="dd-dialog">{{$t('system.inquiry')}}{{isSwitch[2]?$t('system.on'):$t('system.off')}}({{groupItem.name}}){{$t('system.slaveDevice')}}?</div>
    </banned-dialog>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'
import EnfoldUc from '@/components/basics/EnfoldUC'
import DelDialog from '@/components/basics/DelDialog'
import FormDialog from '@/components/basics/FormDialog'
import BannedDialog from '@/components/basics/BannedDialog'
import Utils from "@/assets/scripts/Utils";
import { getChildrenIds } from "@/assets/scripts/publicFunction";
export default {
  name: "OrganizationManage",
  data() {
    return {
      FormDialogVisible: false,
      editDialogVisible: false,
      DelDialogVisible: false,
      onOffDialogVisible: false,
      loading: true,
      switchON: require('@/assets/images/public/public_activate.png'),
      switchOFF: require('@/assets/images/public/public_deactivate.png'),
      groupList: [],
      isSwitch: [],
      groupItem: {},
      editItem: {},
      listForm: {
        name: "",
      },
      editForm: {
        name: "",
      },
      rules: {
        name: [
          { required: true, message: this.$t('csom1'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getGroupList();
  },
  methods: {
    getGroupList() {
      this.loading = true;
      this.$http.post("/admin/access/groupList", {}, data => {
        this.groupList = data;
        this.loading = false;
      });
    },
    FormCloseDialog() {
      this.FormDialogVisible = false;
    },
    editCloseDialog() {
      this.editDialogVisible = false;
    },
    DelCloseDialog(isConfirm = false) {
      if (isConfirm) {
        this.$http.post("/admin/access/delGroup", { id: this.groupItem.id }, data => {
          console.log(data);
          this.getGroupList();
        });
      }
      this.DelDialogVisible = false;
    },
    resetForm(listForm) {
      this.$refs[listForm].resetFields();
      this.FormDialogVisible = false;
    },
    submitForm(listForm) {
      this.$refs[listForm].validate((valid) => {
        if (valid) {
          this.$http.post("/admin/access/addGroup", { pid: this.groupItem.id, name: this.listForm.name }, data => {
            console.log(data);
            this.FormDialogVisible = false;
            this.getGroupList();
          });
          this.$refs[listForm].resetFields();
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetEdit(listForm) {
      this.$refs[listForm].resetFields();
      this.editDialogVisible = false;
    },
    submitEdit(listForm) {
      this.$refs[listForm].validate((valid) => {
        console.log(valid, this.editItem.id, this.editForm.name);
        if (valid) {
          this.$http.post("/admin/access/editGroup", { id: this.editItem.id, name: this.editForm.name }, data => {
            console.log(data);
            this.editDialogVisible = false;
            this.getGroupList();
          });
          this.$refs[listForm].resetFields();
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    append(data) {
      this.groupItem = data;
      this.FormDialogVisible = true;
    },
    edit(data) {
      this.editItem = data;
      this.editForm.name = data.name;
      this.editDialogVisible = true;
    },
    remove(data) {
      this.groupItem = data;
      this.DelDialogVisible = true;
    },
    organizationSwitch(data) {
      this.groupItem = data;
      this.onOffDialogVisible = true;
      this.isSwitch = parseInt(data.run_status) ? ['system.CloseCurrent', 'system.CloseSlave', false] : ['system.OpenCurrent', 'system.OpenSlave', true];
    },
    onOffCloseDialog(isConfirm) {
      let organizationIds = '';
      let isRunStatus = this.isSwitch[2] ? 1 : 0;
      if (isConfirm === false) {
        organizationIds = getChildrenIds(this.groupIdList, this.groupItem.id).join(",");
      } else if (isConfirm === true) {
        organizationIds = this.groupItem.id;
      } else {
        this.onOffDialogVisible = false;
        return;
      }
      this.$http.post("/admin/access/controlGroupList", { run_status: isRunStatus, controlGroupIds: organizationIds }, data => {
        console.log(data);
        // this.getGroupList();
        this.groupList = data;
        this.onOffDialogVisible = false;
      });
    }
  },
  computed: {
    groupIdList() {
      let self = this;
      let data = Utils.MSDataTransfer.treeToArray(
        self.groupList,
        null,
        null,
        self.defaultExpandAll
      );
      return data;
    }
  },
  components: {
    enfold,
    DelDialog,
    FormDialog,
    BannedDialog,
    EnfoldUc
  }
}
</script>

<style lang="scss" scoped>
.organization-manage {
  width: 100%;
  height: 100%;
  .c-u-right {
    padding-right: 64px;
  }
  .el-tree {
    padding: 0px 20px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 8px;
    .icon {
      width: 30px;
      margin-left: 30px;
    }
  }
  /deep/ .el-tree-node__content {
    height: 40px;
    border-bottom: 1px dashed #d9d9d9;
    .el-button {
      margin-left: -26px;
    }
  }
}
</style>